import React from 'react';
import { motion } from 'framer-motion';
const comparisonData = [{
  metric: 'Exclusividad',
  before: 'Compartido con 5+',
  after: '100% Tuyo'
}, {
  metric: 'Costo por Lead',
  before: '$250 - $400 (Y basura)',
  after: '$45 - $85 (Cualificado)'
}, {
  metric: 'Tasa de Cierre',
  before: '10% (Peleando precio)',
  after: '35% - 50% (Autoridad)'
}, {
  metric: 'Previsibilidad',
  before: '"A ver si llaman"',
  after: 'Agenda Llena Diario'
}];
export function ResultsSection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon" data-id="element-297">
      <div className="max-w-5xl mx-auto" data-id="element-298">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-heading font-bold text-gold text-center mb-10 md:mb-16" data-id="element-299">
          Aquí es donde se acaba la opinión y empiezan los contratos.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-300">
          {/* Desktop Table */}
          <div className="hidden md:block bg-[#0A0A0A] border border-[#151515] rounded-xl overflow-hidden shadow-lg" data-id="element-301">
            <table className="w-full text-left border-collapse" data-id="element-302">
              <thead data-id="element-303">
                <tr className="bg-gold/10 border-b border-[#151515]" data-id="element-304">
                  <th className="px-6 py-4 text-gold font-bold text-lg" data-id="element-305">
                    Métrica
                  </th>
                  <th className="px-6 py-4 text-gold font-bold text-lg" data-id="element-306">
                    Antes (Leads Genéricos)
                  </th>
                  <th className="px-6 py-4 text-gold font-bold text-lg" data-id="element-307">
                    Después (Sistema A.C.E.™)
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-308">
                {comparisonData.map((row, index) => <tr key={index} className="border-b border-[#151515] last:border-0" data-id="element-309">
                    <td className="px-6 py-5 text-white font-semibold text-lg" data-id="element-310">
                      {row.metric}
                    </td>
                    <td className="px-6 py-5 text-gray-sec" data-id="element-311">{row.before}</td>
                    <td className="px-6 py-5 text-emerald font-bold text-lg" data-id="element-312">
                      {row.after}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Stacked Cards */}
          <div className="md:hidden space-y-4" data-id="element-313">
            {comparisonData.map((row, index) => <div key={index} className="bg-[#0A0A0A] border border-[#151515] rounded-xl p-5 shadow-lg" data-id="element-314">
                <h3 className="text-white font-semibold text-lg mb-4 border-b border-[#151515] pb-2" data-id="element-315">
                  {row.metric}
                </h3>
                <div className="space-y-3" data-id="element-316">
                  <div data-id="element-317">
                    <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-318">
                      Antes
                    </span>
                    <span className="text-gray-sec" data-id="element-319">{row.before}</span>
                  </div>
                  <div data-id="element-320">
                    <span className="block text-xs text-gold/70 uppercase tracking-wider mb-1" data-id="element-321">
                      Después
                    </span>
                    <span className="text-emerald font-bold text-lg" data-id="element-322">
                      {row.after}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}